import { logoutUserSuccess } from "./reducer";

export const logoutUser = () => async (dispatch: any) => {
  try {
    sessionStorage.removeItem("authUser");
    sessionStorage.removeItem("selectedRole");
    // Preserve the remembered username across logout so "Remember me" keeps working.
    const rememberedUsername = localStorage.getItem("rememberedUsername");
    localStorage.clear();
    if (rememberedUsername) {
      localStorage.setItem("rememberedUsername", rememberedUsername);
    }
    dispatch(logoutUserSuccess(true));
  } catch (error: any) {
    console.error("error: ", error);
  }
};
